import { captureMessage, withScope } from '@sentry/browser'

/** Correlate a browser failure with its server turn without collecting chat content. */
export function reportChatFailure(
  phase: 'send-message' | 'apply-response',
  details: { sessionId: string; status?: number; elapsedMs: number },
) {
  const failureKind = phase === 'apply-response' ? 'client'
    : details.status === 0 ? 'transport'
      : details.status != null && details.status >= 200 && details.status < 300 ? 'response-body' : 'http'
  const tags = { area: 'webster', phase, failureKind }

  withScope(scope => {
    // Console breadcrumbs can contain the original API error or response. Clear inherited
    // event data too, so these diagnostics contain only the approved correlation fields.
    scope.addEventProcessor(event => ({
      ...event, breadcrumbs: [], extra: details, tags,
      request: undefined, user: undefined, contexts: undefined,
    }))
    captureMessage('Webster chat failure', {
      level: 'error', tags, extra: details,
      fingerprint: ['webster', phase, failureKind],
    })
  })
}
